import { RadioGroup, clx } from "@modules/common/components/ui"

type FilterRadioGroupProps = {
  title: string
  items: {
    value: string
    label: string
  }[]
  value: string
  handleChange: (value: string) => void
  /** Lay the options out in a row (toolbar) instead of a column (sidebar) */
  inline?: boolean
  "data-testid"?: string
}

// Switch-style selector: each option carries a 4px status square that lights
// up in signal red when active.
const FilterRadioGroup = ({
  title,
  items,
  value,
  handleChange,
  inline = false,
  "data-testid": dataTestId,
}: FilterRadioGroupProps) => {
  return (
    <div className={clx("flex gap-3", inline ? "flex-row flex-wrap items-center gap-x-5" : "flex-col")}>
      <span className="zl-badge text-zl-steel">{title}</span>
      <RadioGroup data-testid={dataTestId} className={clx("flex", inline ? "flex-row flex-wrap gap-x-5 gap-y-2" : "flex-col gap-y-2")}>
        {items?.map((i) => {
          const active = i.value === value
          return (
            <div key={i.value} className="flex items-center">
              <RadioGroup.Item
                checked={active}
                onChange={() => handleChange(i.value)}
                className="hidden peer"
                id={i.value}
                value={i.value}
              />
              <label
                htmlFor={i.value}
                className={clx(
                  "group flex items-center gap-x-2 font-mono text-xs uppercase tracking-[0.06em] cursor-pointer transition-colors duration-100",
                  active ? "text-zl-ink" : "text-zl-steel hover:text-zl-ink"
                )}
                data-testid="radio-label"
                data-active={active}
              >
                <span
                  className={clx("w-1 h-1 shrink-0", active ? "bg-zl-red" : "bg-zl-mute group-hover:bg-zl-ink")}
                  aria-hidden
                />
                {i.label}
              </label>
            </div>
          )
        })}
      </RadioGroup>
    </div>
  )
}

export default FilterRadioGroup
